import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { FormViewModel, ProgramEnum } from '@program-suite/data-common';

@Injectable({
  providedIn: 'root',
})
export class PolicyFormGridService {
  private readonly http = inject(HttpClient);

  async getPolicyFormGrid(programCode?: ProgramEnum, stateCode?: string): Promise<FormViewModel[]>{
    try {
      const params: any = {};
      if (programCode !== undefined) params.programCode = programCode;
      if (stateCode) params.stateCode = stateCode;
      return await firstValueFrom(
        this.http.get<FormViewModel[]>('Lookup/forms', { params, responseType: 'json' })
      );
    } catch (error) {
      throw new Error('Failed to fetch policy form grid. Please try again later.');
    }
  }
}